var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _vm.loading
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-skeleton-loader", {
                staticClass: "rounded-md",
                attrs: {
                  transition: "fade-transition",
                  type: "list-item-three-line",
                },
              }),
            ],
            1
          )
        : _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              !_vm.$helpers.hasSomePermission(["view_notification"])
                ? _c("PermissionDenied", { attrs: { isDetail: true } })
                : _c(
                    "div",
                    [
                      _c(
                        "v-card",
                        { staticClass: "mb-6", attrs: { flat: "" } },
                        [
                          _c(
                            "v-toolbar",
                            {
                              staticClass: "transparent",
                              attrs: { flat: "", height: "46" },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass:
                                    "px-5 subtitle-2 grey-500--text font-weight-bold",
                                },
                                [_vm._v("Certificado digital")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-toolbar-items",
                                { staticClass: "pr-5" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                        "no-gutters": "",
                                      },
                                    },
                                    [
                                      _c("v-switch", {
                                        staticClass: "my-2",
                                        attrs: {
                                          width: 32,
                                          height: 18,
                                          color: "green-500",
                                          "hide-details": "",
                                          ripple: false,
                                        },
                                        model: {
                                          value:
                                            _vm.showCertificateNotification,
                                          callback: function ($$v) {
                                            _vm.showCertificateNotification =
                                              $$v
                                          },
                                          expression:
                                            "showCertificateNotification",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.showCertificateNotification
                            ? [
                                _c("v-divider"),
                                _c(
                                  "v-card-text",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-list",
                                      {
                                        key: _vm.isReset,
                                        staticClass: "transparent py-2",
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          {
                                            staticClass: "mx-4",
                                            attrs: { "two-line": "" },
                                          },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-subtitle",
                                                  {
                                                    staticClass: "mt-1 body-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Selecciona a qué usuarios se les enviarán notificaciones sobre el vencimiento del certificado digital "
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "px-0 mt-1",
                                                        attrs: { cols: "4" },
                                                      },
                                                      [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            "single-line": "",
                                                            color: "grey-900",
                                                            dense: "",
                                                            outlined: "",
                                                            items:
                                                              _vm.membersList,
                                                            multiple: "",
                                                            chips: false,
                                                            "item-text":
                                                              "email",
                                                            "item-value": "id",
                                                            "append-icon":
                                                              "mdi-chevron-down",
                                                            label: (
                                                              _vm
                                                                .certificateNotifications
                                                                .members || []
                                                            ).length
                                                              ? ""
                                                              : "Selecciona a los usuarios",
                                                            prefix:
                                                              (
                                                                _vm
                                                                  .certificateNotifications
                                                                  .members || []
                                                              ).length >= 1
                                                                ? `${
                                                                    (
                                                                      _vm
                                                                        .certificateNotifications
                                                                        .members ||
                                                                      []
                                                                    ).length ===
                                                                    1
                                                                      ? `${
                                                                          (
                                                                            _vm
                                                                              .certificateNotifications
                                                                              .members ||
                                                                            []
                                                                          )
                                                                            .length
                                                                        } seleccionado`
                                                                      : `${
                                                                          (
                                                                            _vm
                                                                              .certificateNotifications
                                                                              .members ||
                                                                            []
                                                                          )
                                                                            .length
                                                                        } seleccionados`
                                                                  }`
                                                                : "",
                                                            "no-data-text":
                                                              "No existen miembros para mostrar",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "selection",
                                                                fn: function ({
                                                                  props,
                                                                }) {
                                                                  return [
                                                                    props
                                                                      ? _c(
                                                                          "span",
                                                                          {}
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1879759739
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm
                                                                .certificateNotifications
                                                                .members,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.certificateNotifications,
                                                                "members",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "certificateNotifications.members",
                                                          },
                                                        }),
                                                        _c(
                                                          "v-row",
                                                          {
                                                            attrs: {
                                                              "no-gutters": "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0 mt-2",
                                                              },
                                                              _vm._l(
                                                                _vm.chipMembers(
                                                                  _vm
                                                                    .certificateNotifications
                                                                    .members
                                                                ),
                                                                function (
                                                                  m,
                                                                  i
                                                                ) {
                                                                  return _c(
                                                                    "v-chip",
                                                                    {
                                                                      key: `${m}${i}`,
                                                                      staticClass:
                                                                        "mr-2 mb-2 font-weight-light text-lowercase overline chip-users",
                                                                      attrs: {
                                                                        close:
                                                                          "",
                                                                        color:
                                                                          "lightBlue",
                                                                        small:
                                                                          "",
                                                                        label:
                                                                          "",
                                                                        "close-icon":
                                                                          "mdi-close",
                                                                      },
                                                                      on: {
                                                                        "click:close":
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.memberRemove(
                                                                              m,
                                                                              _vm.index
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            m.email
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "d-block",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Se enviará una notificación, antes de los días seleccionados al vencimiento del certificado digital"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        class: [
                                                          `ml-n1 ${
                                                            (
                                                              _vm.chipMembers(
                                                                _vm
                                                                  .certificateNotifications
                                                                  .members
                                                              ) || []
                                                            ).length
                                                              ? ""
                                                              : "mt-1"
                                                          }`,
                                                        ],
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.daysList,
                                                        function (day, d) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: d,
                                                              staticClass:
                                                                "pa-0",
                                                              staticStyle: {
                                                                "min-width":
                                                                  "90px",
                                                              },
                                                              attrs: {
                                                                cols: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("v-checkbox", {
                                                                staticClass:
                                                                  "ma-0 vcheckbox",
                                                                attrs: {
                                                                  value: day,
                                                                  row: "",
                                                                  label: `${day} día${
                                                                    day > 1
                                                                      ? "s"
                                                                      : ""
                                                                  }`,
                                                                  dense: "",
                                                                  "hide-details":
                                                                    "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.rules,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.rules =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "rules",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-divider"),
                                _c(
                                  "v-card-actions",
                                  { staticClass: "px-5 py-4" },
                                  [
                                    _c("v-spacer"),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { outlined: "", ripple: false },
                                        on: { click: _vm.reset },
                                      },
                                      [_vm._v("Cancelar")]
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "grey-900",
                                          ripple: false,
                                          loading:
                                            _vm.loadingcertificateNotifications,
                                          disabled:
                                            !(
                                              (
                                                _vm.certificateNotifications ||
                                                {}
                                              ).members || []
                                            ).length ||
                                            !_vm.$helpers.hasSomePermission([
                                              "change_notification",
                                              "add_notification",
                                            ]),
                                        },
                                        on: {
                                          click: function ($event) {
                                            !(
                                              Object.keys(
                                                _vm.currentNotification(
                                                  "certificate"
                                                )
                                              ) || []
                                            ).length
                                              ? _vm.saveNotifications()
                                              : _vm.updateNotifications()
                                          },
                                        },
                                      },
                                      [_vm._v("Guardar")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }